/**
* @Description 文件功能说明：应用明细
* @Author
* @Time 2022/1/20
**/

/* HTML */
<template>
    <div class="form-model-view">
    	<div class="title-item-box">
        	<span>区域划分信息</span>
    		<el-button class="title-item-btn" icon="el-icon-circle-plus-outline" style="float: right;" @click="add" v-show="!editFlag">新增定位地图</el-button>
        <el-button class="title-item-btn" icon="el-icon-delete" style="float: right;" v-show="!editFlag" @click="del">删除</el-button>
    		<el-button class="title-item-btn" icon="el-icon-save" style="float: right;" v-show="editFlag" @click="cancel">取消</el-button>
    		<el-button class="title-item-btn" icon="el-icon-save" style="float: right;" v-show="editFlag" @click="save">保存编辑</el-button>
    		<el-button class="title-item-btn" icon="el-icon-edit" style="float: right;" v-show="!editFlag" @click="edit">编辑</el-button>
    	</div>
    	<div class="form-unit-box">
    		<el-form :model="rowForm" ref="rowForm" :rules="rules" label-width="140px">
                <el-form-item label="区域id：" >
                    {{nodeData.id}}
                </el-form-item>
                <el-form-item label="区域名称：" prop="areaName">
                    <div v-if="editFlag">
                        <el-input v-model="rowForm.areaName"/>
                    </div>
                    <div v-else>
                        {{nodeData.name}}
                    </div>
                </el-form-item>
                <el-form-item :label="autoMapFlag ? '是否生成地图：' : '是否上传地图：'" prop="hasMap">
                    <div v-if="editFlag">
                        <el-radio-group v-model="rowForm.hasMap" @change="changeHandle">
                            <el-radio class="radio" :label="1" >是</el-radio>
                            <el-radio class="radio" :label="0" >否</el-radio>
                        </el-radio-group>
                    </div>
                    <div v-else>
                        {{rowForm.hasMap==1?'是':'否'}}
                    </div>
                </el-form-item>
                <div v-show="rowForm.hasMap==1">
                    <template>
                    	<!-- 自动生成地图 start -->
	                    <el-form-item class="vertical-form-item p-t-5 p-l-20 content-pt-35" prop="mapFile" v-if="autoMapFlag" v-show="editFlag && rowForm.hasMap" style="margin-bottom: 20px;">
							<span slot="label">
								<span style="padding-right: 0px;"><font color="#F56C6C">*</font>生成地图<i style="padding-left: 0px;">：填写实际测量数据之后点击 生成地图 按钮，自动生成地图 </i></span>
							</span>
							
							<el-form-item class="vertical-form-item m-b-0 float-left p-r-10" label="测量距离横向, 纵向：" prop="realWidth" style="width: calc((100% - 90px) / 2)">
	                            <el-input v-model="rowForm.realWidth">
	                                <template slot="append">米</template>
	                            </el-input>
	                        </el-form-item>
	                        <el-form-item class="vertical-form-item m-b-0 float-left p-r-10" prop="realHeight" style="width: calc((100% - 90px) / 2)">
	                            <el-input v-model="rowForm.realHeight">
	                                <template slot="append">米</template>
	                            </el-input>
	                        </el-form-item>
							<el-form-item class="vertical-form-item m-b-0 float-left p-r-10" style="width: 90px;">
	                            <el-button type="primary" @click.native="creatFile" size="small" style="height: 46px;">生成地图</el-button>
	                        </el-form-item>
	                    </el-form-item>
	                    <!-- 自动生成地图 end -->
                    	
                    	<el-form-item class="row-items-1" label="上传地图：" prop="mapFile" v-else v-show="editFlag && rowForm.hasMap">
	                        <el-upload
	                            style="display: inline-block;"
	                            ref="uploadImg"
	                            accept="image/jpeg,image/jpg,image/png"
	                            :auto-upload="false"
	                            :show-file-list="false"
	                            :before-upload="beforeUpload"
	                            :on-success="uploadSuccess"
	                            :on-error="uploadError"
	                            :action="upload.uploadUrl"
	                            :headers="upload.myHeaders"
	                            :on-change="(file,fileList)=>{return changeFile(file,fileList)}"
	                        ><el-button type="primary" size="mini">上传地图</el-button></el-upload>
	                    </el-form-item>
                    </template>
                    
                	<el-form-item class="row-items-1" label-width="0px" v-show="!emptyMapUrl">
                        <div style="width: 100%;overflow: hidden;">
                            <div class="raphae-map-box h-m-400">
                                <SubRaphaelMap ref="svgMap" :mapEleId="'detailAreaId'"/>
                            </div>
                        </div>
                    </el-form-item>
                    <template v-if="!autoMapFlag || !editFlag">
	                    <el-form-item label="X起点(米)：" prop="startPointX">
	                        <div v-if="editFlag">
	                            <el-input v-model="rowForm.startPointX"/>
	                        </div>
	                        <div v-else>
	                            {{rowForm.startPointX}}
	                        </div>
	                    </el-form-item>
	                    <el-form-item label="Y起点(米)：" prop="startPointY">
	                        <div v-if="editFlag">
	                            <el-input v-model="rowForm.startPointY"/>
	                        </div>
	                        <div v-else>
	                            {{rowForm.startPointY}}
	                        </div>
	                    </el-form-item>
	                    <el-form-item label="Z起点(米)：" prop="startPointZ">
	                        <div v-if="editFlag">
	                            <el-input v-model="rowForm.startPointZ"/>
	                        </div>
	                        <div v-else>
	                            {{rowForm.startPointZ}}
	                        </div>
	                    </el-form-item>
	                    <el-form-item label="X像素(Px)：" prop="startPointXPx">
	                        <div v-if="editFlag">
	                            <el-input v-model="rowForm.startPointXPx"/>
	                        </div>
	                        <div v-else>
	                            {{rowForm.startPointXPx}}
	                        </div>
	                    </el-form-item>
	                    <el-form-item label="Y像素(Px)：" prop="startPointYPx">
	                        <div v-if="editFlag">
	                            <el-input v-model="rowForm.startPointYPx"/>
	                        </div>
	                        <div v-else>
	                            {{rowForm.startPointYPx}}
	                        </div>
	                    </el-form-item>
	                    <el-form-item label="X比例(Px/米)：" prop="scaleX">
	                        <div v-if="editFlag">
	                            <el-input v-model="rowForm.scaleX"/>
	                        </div>
	                        <div v-else>
	                            {{rowForm.scaleX}}
	                        </div>
	                    </el-form-item>
	                    <el-form-item label="Y比例(Px/米)：" prop="scaleY">
	                        <div v-if="editFlag">
	                            <el-input v-model="rowForm.scaleY"/>
	                        </div>
	                        <div v-else>
	                            {{rowForm.scaleY}}
	                        </div>
	                    </el-form-item>
                    </template>
                    
                </div>
	        </el-form>
    	</div>
    </div>
</template>

/* JS */
<script>
    // 公共变量
    import ApiOam from '@/request/api-oam'
    import GlobalFun from "@/global/global-function";
    import SubRaphaelMap from '@/components/SubRaphaelMap'
    // 地图 img
	import defaultImg from '@/static_dazzle/images/template/grid-20px-500x500.png';
    export default {
        /**
         * @Des 组件名
         * @Auth
         * @Date 2022/1/20
         */
        name: 'AreaDetail',
        /**
         * @Des 数据接收类型
         * @Auth
         * @Date 2022/1/20
         */
        props: {
            // 节点信息
            nodeData: Object,
        },
        /**
         * @Des 组件引用
         * @Auth
         * @Date 2021/7/20
         */
        components: {
            // svg地图
            SubRaphaelMap,
        },
        /**
         * @Des 数据定义
         * @Auth
         * @Date 2022/1/20
         */
        data() {
            return{
                editFlag: false,
                operationLock: false,
                // 地图为空
                emptyMapUrl: true,
                rowForm: {
                    areaName: '',
                    hasMap: 0,
                    // 地图 img addr
                    mapAddr: '',
                    // 选取 地图
                    mapFile: '',
                    realWidth: '',
                    realHeight: '',
                    mapUrl: '',
                    startPointX: 0,
                    startPointY: 0,
                    startPointZ: 0,
                    offsetX: 0,
                    offsetY: 0,
                    offsetZ: 0,
                    startPointXPx: '',
                    startPointYPx: '',
                    scaleX: '',
                    scaleY: '',
                },
                row:{},
                
                // flag 自动生成地图
				autoMapFlag: false,
				// flag 点击按钮
				handleAutoFlag: false,
                
                upload:{
                    myHeaders: {
                        token: this.$store.state.token,
                        lang: this.$store.state.lang,
                        loginDevice: this.$store.state.loginDevice
                    },
                    uploadUrl: ApiOam.Upload_Map_Uri,
                },
                rules:{
                    areaName: [
                        { required: true, message: '名称不能为空', trigger: 'blur' }
                    ],
                    mapUrl: [
                        { required: true, message: '地图地址不能为空', trigger: 'blur' }
                    ],
                    mapFile: [
                    	{
                            validator: (rule, value, callback) => {
                                if(this.rowForm.hasMap == 1) {
                                    if (this.$checkEmpty(value) && this.$checkEmpty(this.rowForm.mapUrl)) {
                                        if (this.autoMapFlag) {
                                    		new callback(new Error('请生成地图'))
                                    	} else {
                                    		new callback(new Error('请选择地图'))
                                    	}
                                    } else {
                                        callback()
                                    }
                                }else{
                                    callback()
                                }
                            },
                            trigger: "blur"
                        }
                    ],// mapFile
                    realWidth: [
                        {
                            validator: (rule, value, callback) => {
                                if(!this.handleAutoFlag){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('横向测量距离不能为空'))
                                    } else if (!(parseFloat(value) > 0)) {
                                    	new callback(new Error('横向测量距离应为大于0的数字'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],// realWidth
                    realHeight: [
                        {
                            validator: (rule, value, callback) => {
                                if(!this.handleAutoFlag){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('纵向测量距离不能为空'))
                                    } else if (!(parseFloat(value) > 0)) {
                                    	new callback(new Error('纵向测量距离应为大于0的数字'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],// realHeight
                    startPointX: [
                        { required: true, message: 'X起始点不能为空', trigger: 'blur' }
                    ],
                    startPointY: [
                        { required: true, message: 'Y起始点不能为空', trigger: 'blur' }
                    ],
                    startPointZ: [
                        { required: true, message: 'Z起始点不能为空', trigger: 'blur' }
                    ],
                    startPointXPx: [
                        { required: true, message: 'X像素不能为空', trigger: 'blur' }
                    ],
                    startPointYPx: [
                        { required: true, message: 'Y像素不能为空', trigger: 'blur' }
                    ],
                    scaleX: [
                        { required: true, message: 'X比例不能为空', trigger: 'blur' }
                    ],
                    scaleY: [
                        { required: true, message: 'Y比例不能为空', trigger: 'blur' }
                    ],
                },

                // 地图信息
                mapOption: {},
                // 地图模块
                mapSub: null,
				
            }
        },
        /**
         * @Des 监听
         * @Auth
         * @Date
         */
        watch: {
            nodeData: {
                handler(newVal, oldVal){
                    // 查询数据
            		this.searchRow();
                },
                immediate: true,
                deep:true,
            }
        },
        mounted(){
            // flag 自动生成地图
            this.autoMapFlag = this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e8';
            // 重新加载数据
            this.$nextTick(() => {
                //this.searchRow();

            })
        },
        /**
         * @Des 销毁
         * @Auth
         * @Date
         */
        destroyed() {
            // 销毁 svg地图
            this.$refs.svgMap && this.$refs.svgMap.destroySvg();
        },
        /**
         * @Des 方法定义
         * @Auth
         * @Date 2022/1/20
         */

        methods:{
            /**
	         * @Des 更改是否有地图
	         * @Auth
	         * @Date
	         */
            changeHandle(value){
                this.rowForm.hasMap = value;
                // 空值 重置
                if (this.nodeData.node.hasMap != 1) {
                	this.rowForm.startPointX = !this.$checkEmpty(this.rowForm.startPointX) ? this.rowForm.startPointX : 0;
                    this.rowForm.startPointY = !this.$checkEmpty(this.rowForm.startPointY) ? this.rowForm.startPointY : 0;
                    this.rowForm.startPointZ = !this.$checkEmpty(this.rowForm.startPointZ) ? this.rowForm.startPointZ : 0;
                    this.rowForm.offsetX = 0;
                    this.rowForm.offsetY = 0;
                    this.rowForm.offsetZ = 0;
                }
                // 地图数据 初始化
                this.initMapData();
            },
            /**
	         * @Des 检索是否有地图
	         * @Auth
	         * @Date
	         */
            checkMapUrl() {
                this.emptyMapUrl = this.$checkEmpty(this.rowForm.mapFile) && this.$checkEmpty(this.rowForm.mapUrl);
            },

            /**
             * @Des 查询数据
             * @Auth
             * @Date
             */
            searchRow() {
                /*
                this.rowForm = Object.assign({}, this.nodeData.node);
                // 检索是否有地图
                this.checkMapUrl();

                // 有地图
                if (this.rowForm.hasMap == 1) {
                	// 地图信息
                	this.mapOption = Object.assign({}, this.rowForm);
                	//this.mapOption.mapUrl = GlobalVariable.BASE_PATH + this.mapOption.mapUrl;
                	this.mapOption.mapUrl = 'data:image/png;base64,' + this.mapOption.mapUrl;

                    this.$nextTick(() => {
	                	// 初始化 svg地图
	                    if(!this.mapSub){
	                        this.mapSub = this.$refs.svgMap;
	                    }
                    	// 初始化地图
	                    this.mapSub.initMap(this.mapOption);
	                    // 绘制圆点
	                    this.mapSub.initDrawDisc([this.mapOption.startPointXPx, this.mapOption.startPointYPx].join(','), 5);
                    });
                }
                return false;
                */
            	
                this.$request.postJsonRequest(ApiOam.Find_Area_By_Id_Uri, {
                    areaId: this.nodeData.id
                }).then(result => {
                    if(result.code == 0){
                        this.rowForm = Object.assign({}, result.data);
                        // 检索是否有地图
                        this.checkMapUrl();

                        // 有地图
                        if (this.rowForm.hasMap == 1) {
                        	// 地图信息
                        	this.mapOption = Object.assign({}, this.rowForm);
                        	//this.mapOption.mapUrl = GlobalVariable.BASE_PATH + this.mapOption.mapUrl;
                        	this.mapOption.mapUrl = 'data:image/png;base64,' + this.mapOption.mapUrl;

		                    this.$nextTick(() => {
	                        	// 初始化 svg地图
			                    if(!this.mapSub){
			                        this.mapSub = this.$refs.svgMap;
			                    }
		                    	// 初始化地图
			                    this.mapSub.initMap(this.mapOption);
			                    // 绘制圆点
			                    this.mapSub.initDrawDisc([this.mapOption.startPointXPx, this.mapOption.startPointYPx].join(','), 5);
		                    });
                        }
                    }
                }).catch(error => {
                    console.error('根据id查询区域异常', ApiOam.Find_Area_By_Id_Uri, error);
                })
            },

            /**
             * 编辑
             */
            edit(){
                this.rowForm.id = this.nodeData.id;
                this.rowForm.areaName = this.nodeData.name;
                //this.rowForm = Object({}, this.nodeData);
                this.editFlag = true;
				
				// 地图数据 初始化
                this.initMapData();
				
                // 双击取点
                this.mapSub && this.mapSub.allowDrawDisc(!this.autoMapFlag, (startX, startY) => {
                    // 起始点X
                    this.rowForm.startPointXPx = startX;
                    // 起始点X
                    this.rowForm.startPointYPx = startY;
                });
            },
            /**
             * 取消
             */
            cancel(){
                // 清空验证
                this.$refs.rowForm.clearValidate();
                this.rowForm.hasMap = Object.assign({}, this.nodeData.node).hasMap;
                
                this.editFlag = false;
                // 交互锁
                this.operationLock = false;

                // 双击取点
                this.mapSub && this.mapSub.allowDrawDisc(false, (startX, startY) => {
                    // 起始点X
                    this.rowForm.startPointXPx = startX;
                    // 起始点X
                    this.rowForm.startPointYPx = startY;
                });

                this.$nextTick(() => {
                	// 查询数据
                	this.searchRow();
                });
            },
            /**
             * 保存
             */
            save(){
                if (this.operationLock) return false;
                this.$refs.rowForm.validate(valid => {
                    if (!valid) return false;
                    this.operationLock = true;
					
					// 提交数据 交互
					this.requestSubmit();
                    
                    return false;
                    if (this.rowForm.hasMap == 1 && !this.$checkEmpty(this.rowForm.mapFile)) {
                        // 编辑 && 更改地图

                        // 上传图片
                        this.$refs['uploadImg'].submit();

                    } else {
                        // addr
                        this.rowForm.mapAddr = this.rowForm.mapUrl;
                        // 提交数据 交互
                        this.requestSubmit();
                    }

                });
            },

            /**
             * @Des 提交交互
             * @Auth
             * @Date
             */
            requestSubmit() {
            	// 区域无地图 => 重置起点和偏移量
            	if (this.rowForm.hasMap != 1) {
            		// 区域无地图

            		this.rowForm.startPointX = 0;
                    this.rowForm.startPointY = 0;
                    this.rowForm.startPointZ = 0;
            	}
				
				let mapAddr;
				let mapHeight;
				let mapWidth;
            	if (this.rowForm.hasMap == 1) {
            		mapAddr = !this.$checkEmpty(this.mapOption.mapUrl) ? this.mapOption.mapUrl.split('base64,')[1] : this.rowForm.mapUrl;
            		mapHeight = !this.$checkEmpty(this.mapOption.mapHeight) ? this.mapOption.mapHeight : this.rowForm.height;
            		mapWidth = !this.$checkEmpty(this.mapOption.mapWidth) ? this.mapOption.mapWidth : this.rowForm.width;
            	}
				
				let formData = Object.assign({}, {
                    areaId: this.nodeData.id,
                    areaName: this.rowForm.areaName,
                    hasMap: this.rowForm.hasMap,
                    mapAddr: mapAddr,//this.rowForm.mapAddr,
                    height: mapHeight,
                    width: mapWidth,
                    offsetX: 0,
                    offsetY: 0,
                    offsetZ: 0,
                    startPointX: this.rowForm.startPointX,
                    startPointY: this.rowForm.startPointY,
                    startPointZ: this.rowForm.startPointZ,
                    startPointXPx: this.rowForm.startPointXPx,
                    startPointYPx: this.rowForm.startPointYPx,
                    scaleX: this.rowForm.scaleX,
                    scaleY: this.rowForm.scaleY,
                });
                
            	this.$request.postJsonRequest(ApiOam.Update_Area_Uri, formData).then(result => {
                    if (result.code == 0) {
                        this.$message({
                            message: '保存成功！',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        
                        let nodeData = Object.assign({}, this.nodeData);
                        nodeData.name = this.rowForm.areaName;
                        nodeData.node = Object.assign({}, nodeData.node, formData);
                        
                        this.$emit('setSelectVal', nodeData, true);

                        this.$nextTick(() => {
                        	this.cancel();
                        });
                    } else {
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }

                    // 交互锁
                    this.operationLock = false;
                }).catch(error => {
                	// 交互锁
                	this.operationLock = false;
                	console.error('修改区域异常', ApiOam.Update_Area_Uri, error);
                })
            },

            /**
             * 添加
             */
            add(){
                this.$emit("addNode", true);
            },
            /**
             * 删除
             */
            del(){
                // 交互锁
                if (this.operationLock) return false;
                this.$confirm('确认要删除【' + this.nodeData.name + '】吗？','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$request.postJsonRequest(ApiOam.Delete_Area_Uri, {
                        areaId: this.nodeData.id
                    }).then(result => {
                        if(result.code == 0){
                            this.$message({
                                message: '【' + this.nodeData.name + '】删除成功！',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            this.$emit('setSelectVal', false, true);
                        }else{
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                        // 交互锁
                    	this.operationLock = false;
                    }).catch(error => {
                        // 交互锁
                    	this.operationLock = false;
                    	console.error('删除区域异常', ApiOam.Delete_Area_Uri, error);
                    })
                }).catch(() => {
                    // 交互锁
                    this.operationLock = false;
                })
            },
            /**
             * @Des 文件上传 change
             * @Auth
             * @Date 2021/7/22
             */
            beforeUpload(file){
                // 上传之前
                //console.log(file)
                let extension = file.name.substring(file.name.lastIndexOf('.')+1);
                let size = file.size/1024/1024;
                // console.log(extension, size)
                if(['png', 'jpg', 'jpeg'].indexOf(extension) === -1) {
                    this.$message.warning('只能上传后缀是 .png/.jpg/.jpeg 的文件');
                } else if(size > 100) {
                    // this.$message.warning('文件大小不得超过100M');
                }
            },
            /**
             * @Des 文件上传 change
             * @Auth
             * @Date 2021/7/22
             */
            uploadSuccess(res, file, fileList) {
                // 上传成功
                //console.log({res, file, fileList});
                if(res.code == 0){
                    // 返回数据
                    // console.log(res.data)

                    let mapAddr = '';
                    if (!this.$checkEmpty(res.data) && !this.$checkEmpty(res.data.path)) {
                        mapAddr = res.data.path;
                    }

                    this.rowForm.mapFile = '';
                    this.rowForm.mapAddr = mapAddr;

                    // 提交数据 交互
                    this.requestSubmit();

                }else{
                    this.$message({
                        type: 'error',
                        message: res.msg ,
                        dangerouslyUseHTMLString: true
                    });
                    // 交互锁
                    this.operationLock = false;
                }
            },
            /**
             * @Des 文件上传 change
             * @Auth
             * @Date 2021/7/22
             */
            uploadError(err, file, fileList) {
                // 上传失败
                this.$message({
                    type: 'error',
                    message: err.msg ,
                    dangerouslyUseHTMLString: true
                });
                // 交互锁
                this.operationLock = false;
            },
            /**
             * @Des 文件上传 change
             * @Auth
             * @Date 2021/7/20
             */
            changeFile(file,fileList) {
                // console.log(file)

                // 交互锁
                this.operationLock = false;

                let _this = this;
                // file 转换成 base64
                GlobalFun.readFileImg(file.raw, data => {
                    this.mapOption.mapUrl = data.src;
                    this.mapOption.mapHeight = data.height;
                    this.mapOption.mapWidth = data.width;
                    this.rowForm.mapFile = data.src;

					// 检索是否有地图
            		this.checkMapUrl();
                    // console.log(this.rowForm)

                    // 初始化 svg地图
                    if(!this.mapSub){
                        this.mapSub = this.$refs.svgMap;
                    }
                    this.mapSub.initMap(this.mapOption);
                    // 双击取点
                    this.mapSub.allowDrawDisc(true, (startX, startY) => {
                        // 起始点X
                        this.rowForm.startPointXPx = startX;
                        // 起始点X
                        this.rowForm.startPointYPx = startY;
                    });
                });
            },// changeFile
            
            /**
			 * @Des 地图数据 初始化
			 * @Auth
			 * @Date
			 */
            initMapData() {
            	// flag 自动生成地图
				this.autoMapFlag = this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e8';
            	// 自动生成地图
            	if (this.autoMapFlag) {
            		// 地图数据
            		this.rowForm['startPointXPx'] = this.rowForm.hasMap != 1 ? '' : 0;
            		this.rowForm['startPointYPx'] = this.rowForm.hasMap != 1 ? '' : 0;
            		this.rowForm['scaleX_map'] = this.rowForm.hasMap != 1 ? '' : 20;
            		this.rowForm['scaleY_map'] = this.rowForm.hasMap != 1 ? '' : 20;
            		this.rowForm['scaleX_real'] = this.rowForm.hasMap != 1 ? '' : 2;
            		this.rowForm['scaleY_real'] = this.rowForm.hasMap != 1 ? '' : 2;
            		this.rowForm['scaleX'] = this.rowForm.hasMap != 1 ? '' : [this.rowForm.scaleX_map, this.rowForm.scaleX_real].join('/');
            		this.rowForm['scaleY'] = this.rowForm.hasMap != 1 ? '' : [this.rowForm.scaleY_map, this.rowForm.scaleY_real].join('/');
            	}
            },// initMapData
            /**
			 * @Des 生成地图
			 * @Auth
			 * @Date
			 */
            creatFile() {
            	// flag 点击按钮
				this.handleAutoFlag = true;
            	this.$refs.rowForm.clearValidate(['mapFile']);
            	
            	let validFlag = true;
            	this.$refs.rowForm.validateField('realWidth', (err) => {
            		if (err) validFlag = false;
            	});
            	this.$refs.rowForm.validateField('realHeight', (err) => {
            		if (err) validFlag = false;
            	});
            	// flag 点击按钮
				this.handleAutoFlag = false;
            	
            	// 验证未通过 中止
            	if (!validFlag) return false;
            	
            	let scaleXs = [this.rowForm.scaleX_map, this.rowForm.scaleX_real];
            	let scaleYs = [this.rowForm.scaleY_map, this.rowForm.scaleY_real];
            	// 参数 地图
				this.mapOption.mapWidth = Math.ceil((this.rowForm.realWidth * scaleXs[0] / scaleXs[1]) / 20) * 20;
				this.mapOption.mapHeight = Math.ceil((this.rowForm.realHeight * scaleYs[0] / scaleYs[1]) / 20) * 20;
				
				// 比例 地图
				this.mapOption.scaleX = [this.rowForm.scaleX_map, this.rowForm.scaleX_real].join('/');
				this.mapOption.scaleY = [this.rowForm.scaleY_map, this.rowForm.scaleY_real].join('/')
				
				// 裁剪的地图
				this.$SubFn.sliceImg({
					src: defaultImg,
					rect: {
						x: 0, // 截取方格左上角横坐标
						y: 0, // 截取方格左上角纵坐标
						width: this.mapOption.mapWidth, // 截取方格宽度
						height: this.mapOption.mapHeight // 截取方格高度
					}
				}).then(result => {
					
					this.mapOption.mapUrl = result;
                    this.rowForm.mapFile = result;
					
					// 检索是否有地图
					this.checkMapUrl();
                    // console.log(this.rowForm)
					
                    // 初始化 svg地图
                    if(!this.mapSub){
                        this.mapSub = this.$refs.svgMap;
                    }
                    
                    this.mapSub.initMap(this.mapOption);
                    // 绘制圆点
                    this.mapSub.initDrawDisc([this.rowForm.startPointXPx, this.rowForm.startPointYPx].join(','), 5);
                    // 双击取点
                    /*this.mapSub.allowDrawDisc(true, (startX, startY) => {
                        // 起始点X
                        this.rowForm.startPointXPx = startX;
                        // 起始点X
                        this.rowForm.startPointYPx = startY;

                        // 表单校验
						this.$refs.rowForm.validateField('startPointXPx', error => {});
						this.$refs.rowForm.validateField('startPointYPx', error => {});
                    });*/
                    // 允许 比例图元
                    this.mapSub.allowShowScaleLine(false);
                    
				}).catch(error => {
					this.mapOption.mapUrl = '';
                    this.rowForm.mapFile = '';
                    // 检索是否有地图
					this.checkMapUrl();
				});// this.$SubFn.sliceImg
            },// creatFile
            
        }// methods
    }
</script>

/* CSS */
<style lang="scss" scoped >

</style>



// WEBPACK FOOTER //
// src/components_pages/Organization/AreaDetail.vue